module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-18.b65a5e84.png";